import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faPhotoFilm,faSliders,faCheck,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faUsers,faBus, faMapLocationDot, faFlag, faRulerVertical, faSquareArrowUpRight,faArrowRight,faChevronDown, faChevronUp, faBolt, faFile,faMessage} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin, } from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect} from 'react'
import PackageSlider from "./Component/PackageSlider";
import OBookingform from "./Component/obookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Sites",
    days: "1 Days",
    difficulty: "Easy",
    price: 190,
    duration: "8-9 Hours",
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Everest Heli Tour",
    days: "4 Hours",
    difficulty: "Easy",
    price: 1400,
    duration: "4 Hours",
    image: "/img/mounteve/Heli1.webp",
    link: "/Everest-Heli-Tour"
  },
  {
    title: "The Big Four",
      days: "1 Days",
    difficulty: "Easy",
    price: 140,
    duration: "6 Hours",
    image: "/img/capital/swyambhunathdslr.jpeg",
    link: "/One-Day-kathmandu-Tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  }
];
const images = [
   "/img/company/airportdslr.jpeg",
   "/img/company/flightdslr.jpeg",
  "/img/mounteve/moun3.jpg",
  "/img/mounteve/moun1.webp",
  "/img/mounteve/moun2.webp",
  "/img/mounteve/moun.webp",
  "/img/company/medslr.jpeg",
];
const MHeliTour = () => {
  const [open, setOpen] = useState(false);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [index, setIndex] = useState(0);
const getmul=(qty)=>{
if(qty===1)return 280;
if(qty>=2 && qty<=3)return 275;
if(qty>=4 && qty<=7)return 270;
if(qty>=8)return 265;
};
const totalprice =count*getmul(count);
const [opent, seT] = useState(false);
const [opente, seTe] = useState(false);
const [openr, seTr] = useState(false);
useEffect(()=>{
  if(opent){
    document.body.style.overflow='hidden';
  }
  else{
    document.body.style.overflow='unset';
  }
  return()=>{
    document.body.style.overflow='unset';
  }
},[opent]);
const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Mountain Flight Tour</h1>

    <div className="breadcrumb">
    <span>Mountain Flights Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/mounteve/moun1.webp" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>  
        </div>
        <div className="everest-half">
            <div className="image-box"> <img src="/img/company/groupphoto.jpeg" alt="error" /></div>
            <div className="image-box"> <img src="/img/mounteve/moun2.webp" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>1 Hours</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Mar-May/Aug-Dec</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Flight With Window Seats</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Enjoying Mountain Views</p>
          </div>
        </div>

         <div className="grid-item">
          <FontAwesomeIcon icon={faFlag}/>
          <div className="grid-item-next">
            <p className='Dur'>Trip Starts&End</p>
            <p className='Duration'>Kathmandu</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faUsers}/>
          <div className="grid-item-next">
            <p className='Dur'>Minimum Pax</p>
            <p className='Duration'>1 Pax</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faRulerVertical}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>19000 Ft</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Front-row window seats guaranteed for every single passenger to witness Everest.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Exclusive cockpit access offers a rare pilot’s view of Himalayan peaks.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore different city of Nepal which is on the way of Different Mountain Ranges.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Capture professional-grade aerial photographs of the world’s highest mountain ranges.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> We handle all the permits, logestics and tickets; you only enjoy the views.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Receive an official signed certificate commemorating your flight to the top</p>
  </div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
  Why spend fourteen days trekking when the majesty of the world’s highest mountains can be yours in just one hour? This elite aerial expedition departs from Kathmandu every morning, offering a sophisticated shortcut to the absolute limits of geography. Designed for those who demand the extraordinary, the Everest Express delivers a lifetime of wonder in the time it takes to have breakfast. From the moment the engine roars to life, you are transported into a realm of ice, rock, and sky that few humans will ever witness so closely.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Mount Everest (8848m):</b> The Earth's Crown</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Mount Lhotse (8516m):</b> The Romantic Giant</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Mount Ama Dablam (6812m):</b> The Matterhorn of the Himalayas</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>The Khumbu Glacier:</b> The River of Ice</p>
  </div>
  <div className="heading smalling">Introduction Of Places</div>
  <p className='overview-text'><b>Mount Everest (8848m): The Earth's Crown</b> Dominating the horizon, the highest point on our planet stands as a testament to the raw power of nature. Watch as the morning sun hits the "Third Pole," turning the black rock and white snow into a glowing pyramid of gold. This is the closest most humans will ever get to the summit, providing a perspective that even seasoned climbers envy.</p>
  <p className='overview-text'><b>Mount Lhotse (8516m): The Romantic Giant</b> Standing tall as the world’s fourth-highest mountain, Lhotse is often connected to Everest via the South Col. Its sheer ice faces and sharp ridges create a dramatic silhouette that defines the Khumbu landscape. Seeing its massive south face from the air reveals a hidden architecture of stone that is invisible from the ground.</p>
  <p className='overview-text'><b>Mount Ama Dablam (6812m): The Matterhorn of the Himalayas</b> Widely considered the most beautiful mountain in the world, its name translates to "Mother’s Necklace." The hanging glacier on its face resembles a traditional pendant, shimmering against the deep blue of the high-altitude sky. Its unique, symmetrical shape makes it a favorite for photographers looking for the "perfect" Himalayan shot.</p>
  <p className='overview-text'><b>The Khumbu Glacier: The River of Ice</b> Witness the largest glacier in Nepal, a massive, slow-moving river of ice that carves its way through the valley floor. From your bird's-eye view, the deep crevasses and turquoise glacial pools look like a sapphire mosaic set in a bed of white. It is a stunning reminder of the ancient forces that continue to shape our world.</p>
</div>


<div className="overview-container">
  <div className="overview-heading">Why This Package ?</div>
 <p className='overview-text'>This short yet unforgettable Mountain Flight tour is designed for travelers who want to see the Himalayas without long trekking days. It is ideal for tourists with limited time who still want a premium mountain adventure.</p>
 <div className="heading smalling">Uncompromising Safety Standards</div>
 <p className='overview-text'>We partner only with elite airlines that maintain a fleet of modern, pressurized aircraft specifically designed for high-altitude reconnaissance. Our pilots are Himalayan veterans with thousands of flight hours, ensuring your journey is as smooth as it is spectacular. Safety is our baseline, allowing you to focus entirely on the horizon.</p>
 <div className="heading smalling">The "View-First" Guarantee</div>
 <p className='overview-text'>Unlike standard commercial flights, our mountain expeditions are strictly weight-managed to ensure every single guest has a dedicated window. We never overbook or place passengers in middle seats, because we believe the view of Everest shouldn't be shared through a shoulder. Your personal portal to the peaks is our top priority.</p>
 <div className="heading smalling">Seamless VIP Logistics</div>
 <p className='overview-text'>From the moment our private chauffeur picks you up at your hotel to the moment you are dropped back for brunch, we handle every detail. Skip the chaotic airport queues with our expedited check-in process and dedicated lounge access. We treat your time with the respect it deserves, ensuring a stress-free transition from earth to sky.</p>
 <div className="heading smalling">Expert Narrated Journey</div>
 <p className='overview-text'>You won't just be looking at mountains; you will be understanding them. Each flight includes a professional guide who provides a live commentary on the history, geology, and mythology of the peaks passing by your window. This intellectual layer transforms a beautiful flight into a profound educational experience that stays with you forever.</p>
 <div className="heading smalling">Climate-Conscious Exploration</div>
 <p className='overview-text'>We are committed to preserving the very peaks we admire. A portion of every ticket goes toward local Himalayan conservation projects and carbon-offsetting initiatives. Choosing us means you are choosing a travel partner that respects the environmental integrity of the Everest region, ensuring these glaciers remain for generations to come.</p>
 <div className="heading smalling">Exclusive Post-Flight Celebration</div>
 <p className='overview-text'>The experience doesn't end when the plane touches down. We host a private post-flight gathering where you receive your certificate and a digital photo package of your journey. It’s a moment to connect with fellow explorers and process the magnitude of what you just witnessed over a hot cup of Himalayan coffee.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
        </div>

        <div
          className="timeline-right"
          onClick={() => setDay1Open(!day1Open)}
        >
         
          <div className="timeline-title">
            Climbing Mt Everest Without Physically Climbing
          </div>

          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>

      {day1Open && (
        <div className="timeline-detail">
         <b>05:30 AM:</b> Private SUV pickup from your hotel in Kathmandu for airport transfer.
        <br></br>
<b>06:00 AM:</b> Expedited check-in at the domestic terminal followed by a safety briefing.
<br></br>
<b>06:30 AM:</b> Take-off into the dawn sky as the Kathmandu Valley fades below.
<br></br>
<b>07:00 AM:</b> Orbiting the Everest massif; time for cockpit visits and champagne service.
<br></br>
<b>07:30 AM:</b> Landing back in Kathmandu followed by the official certificate award ceremony.
<br></br>
<b>08:15 AM:</b> Private transfer back to your hotel.
        </div>
      )}

 
</div>
<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          All the Permit Fee is included.
          </div>
        </div>


        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Fare of the Mountain Flight for 1hours flight</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Life Insurance provided by aviation during a Mountain flight.</div>
        </div>
      </div>



      {/* COST EXCLUDED */}
      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Accommodation in Kathmandu is not Included</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Other Expenses like Mineral Water,Beaverage is not Included.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Your Expenses like Tips is not Included.</div>
        </div>
      </div>

</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
                There is need of payment to book this package you need to pay 100% Charge for booking while there is refund policies incase of cancellation see below.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details in desktop and little bit below in mobile screen or from contact us page where is QR also for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
               This package is perfectly suited for the time-conscious traveler, luxury seeker, or photography enthusiast who wants to experience the Himalayas without the physical demands of trekking. It is an excellent choice for families with children or seniors who wish to witness the world’s highest peaks in total comfort. If you have a passion for "bucket list" milestones but only one morning to spare, this flight was designed specifically for you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies also Cancel up to 24 hours in advance for a full refund.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
   <p style={{padding:"4px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Dress in Layers:</b> Wear a warm down jacket over a fleece; temperatures drop significantly once you land in the mountains.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Device Prep:</b> Charge your phone and camera fully; the mountain cold can drain batteries faster than usual.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Health & Hydration:</b> Drink plenty of water before the flight and carry a small bottle to help with the altitude.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Quick Access:</b> Keep your ID/Passport copy and some local cash handy for Tipping</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
                For the standard 1-hour fixed-wing flight, meals are not served on board the aircraft due to the short duration and high-altitude maneuvers. Instead, the package is designed as a "Sunrise Adventure".
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a One hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize"onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review"onClick={()=>seTr(true)} >
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$280</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                 
                  <h6>See Terms & Condition</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button  onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
    </div>
     </section>
     {opent &&(<section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <OBookingform src="/img/mounteve/moun1.webp" title="One Hour Mountain flight"/></section> )}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/mounteve/moun1.webp" title="One Hour Mountain flight"/></section>)}
{openr &&( <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>)}
   </main>
  )
}
export default MHeliTour